import { Chip } from '@otp/ui';
import {
  WttpQuestionnaireStatus,
  WttpQuestionStatus,
  WttpTemplateStatus,
} from 'src/graphql/generated/graphql';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const StatusColumn = ({
  isActive,
  status,
}: {
  isActive: boolean;
  status?:
    | WttpTemplateStatus
    | WttpQuestionStatus
    | WttpQuestionnaireStatus
    | null;
}) => {
  const { t } = useTranslation();

  if (!isActive) {
    return <Chip label={t('wttp.status.archived')} color="warning" />;
  }

  const calculatedStatusText =
    status === WttpTemplateStatus.Active
      ? t('wttp.status.active')
      : t('wttp.status.draft');

  return (
    <Chip
      label={calculatedStatusText}
      color={status === WttpTemplateStatus.Active ? 'primary' : 'default'}
    />
  );
};
